import { useMutation } from '@tanstack/react-query';
import { Identifier, useNotify, useRefresh } from 'react-admin';
import { httpClient } from '../../DataProvider';

const runAsync = (merchantId?: Identifier): Promise<unknown> => {
  const scannerUrl = import.meta.env.VITE_SCANNER_URL;
  const scanEndpoint = merchantId ? `${scannerUrl}/shops/` : `${scannerUrl}/AllShops`;
  return new Promise((resolve, reject) => {
    httpClient(`${scanEndpoint}`, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: merchantId ? `[${merchantId}]` : undefined,
    })
      .then((response) => {
        if (response.status >= 400) {
          throw new Error('Network response was not ok');
        }
        return response.json;
      })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
};

type UseRunScanMutation = (merchantId?: Identifier) => {
  handleRunScan: () => Promise<void>;
  isLoading: boolean;
};

export const useRunScanMutation: UseRunScanMutation = (merchantId) => {
  const mutation = useMutation({ mutationFn: () => runAsync(merchantId) });
  const notify = useNotify();
  const refresh = useRefresh();

  const handleRunScan = async (): Promise<void> => {
    try {
      const newScanId = await mutation.mutateAsync();
      notify(`Scan initiated successfully: ${newScanId}`, { type: 'success' });
      refresh();
    } catch (error) {
      notify(`Error initiating scan: ${(error as Error).message}`, { type: 'warning' });
    }
  };

  return {
    handleRunScan,
    isLoading: mutation.isPending,
  };
};
